import { render } from "./LImpact.vue?vue&type=template&id=3fdd2f72"
import script from "./LImpact.vue?vue&type=script&lang=js"
export * from "./LImpact.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__